import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Breadcrumb from "../../components/Breadcrumb";
import NotificationsTab from "./NotificationsTab";

const TABS = [
  { key: "notifications", labelKey: "notifications.tab.title" },
];

function UserSettings() {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState(TABS[0].key);

  return (
    <>
      <Breadcrumb items={[{ label: t("notifications.tab.page_title") }]} />
      <div className="card">
        <ul className="nav nav-tabs nav-tabs-v2 px-3">
          {TABS.map((tab) => (
            <li key={tab.key} className="nav-item me-2">
              <button
                type="button"
                className={`nav-link px-2 ${activeTab === tab.key ? "active" : ""}`}
                onClick={() => setActiveTab(tab.key)}
              >
                {t(tab.labelKey)}
              </button>
            </li>
          ))}
        </ul>
        <div className="tab-content p-3">
          {activeTab === "notifications" && <NotificationsTab userId="me" />}
        </div>
      </div>
    </>
  );
}

export default UserSettings;
